import updateClass from '../css/updateClass';
import updateStyleByRef from '../css/updateStyleByRef';
import getDefaultStyle from '../css/defaultStyle';
import getDisabledStyle from '../css/disabledStyle';
import cloneDeep from 'lodash-es/cloneDeep';
import merge from 'lodash-es/merge';
import lookAndFeel from '../lookAndFeel';

const cssClass = [
  {
    selector: '>.body',
    properties: {
      borderColor: '${schemeForeground}',
      borderRadius: '8px',
      borderStyle: 'solid',
      borderWidth: '1px',
      boxShadow: '0px 0px 6px 1px rgba(0,0,0,0.6)',
      overflow: 'visible',
      position: 'absolute',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
      backgroundColor: '${schemeSysBackground}',
    },
  },
  {
    selector: '>.body>.title',
    properties: {
      // textShadow: [
      //   '0px 0px 3px ${schemeSysBackground}',
      //   '2px 0px 3px ${schemeSysBackground}',
      //   '2px 2px 3px ${schemeSysBackground}',
      //   '0px 2px 3px ${schemeSysBackground}',
      //   '-2px 2px 3px ${schemeSysBackground}',
      //   '-2px 0px 3px ${schemeSysBackground}',
      //   '-2px -2px 3px ${schemeSysBackground}',
      //   '0px -2px 3px ${schemeSysBackground}',
      //   '-2px 2px 3px ${schemeSysBackground}',
      // ].join(),
      // backgroundColor: '${schemeSysBackground}',
      // boxShadow: '0px 0px 5px 2px ${schemeSysBackground}',
      filter:
        'drop-shadow(0px 0px 2px ${schemeSysBackground}) ' +
        'drop-shadow(1px 0px 2px ${schemeSysBackground}) ' +
        'drop-shadow(-1px 0px 2px ${schemeSysBackground}) ' +
        'drop-shadow(0px 1px 2px ${schemeSysBackground}) ' +
        'drop-shadow(0px -1px 2px ${schemeSysBackground})',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      borderColor: '${schemeForeground}',
      color: '${schemeForeground}',
      fontSize: '${schemeFontSize}',
      padding: '0px',
      position: 'absolute',
      userSelect: 'none',
    },
  },
  {
    selector: '>.body>.title.top',
    properties: {
      top: '0px',
      transform: 'translate(0,-50%)',
      margin: '0px ${schemeFontSize}',
    },
  },
  {
    selector: '>.body>.title.bottom',
    properties: {
      bottom: '0px',
      transform: 'translate(0,50%)',
      margin: '0px ${schemeFontSize}',
    },
  },
  {
    selector: '>.body>.title.left',
    properties: {
      left: '0px',
      transformOrigin: 'top left',
      transform: 'rotate(-90deg) translate(-100%,-50%)',
      margin: '${schemeFontSize} 0px',
    },
  },
  {
    selector: '>.body>.title.right',
    properties: {
      right: '0px',
      transformOrigin: 'top right',
      transform: 'rotate(-90deg) translate(0%,-50%)',
      margin: '${schemeFontSize} 0px',
    },
  },
];

updateClass(
  'io-frame-default-style',
  updateStyleByRef(cloneDeep(cssClass), lookAndFeel()),
  '.io-frame-default'
);

const cssStyle = {
  normal: merge({}, getDefaultStyle(), {
    position: 'absolute',
    transitionProperty: 'all',
    transitionDuration: '${schemeAnimationDuration}',
    transitionTimingFunction: 'ease',
    transitionDelay: '0s',
    boxSizing: 'border-box',
    height: '80px',
    left: '8px',
    top: '8px',
    width: '160px',
    display: 'inline-block',
    margin: '0px',
    zIndex: 0,
  }),
};

function createElement() {
  const element = document.createElement('div');
  element.classList.add('io-frame-default');
  element.classList.add('controls');
  element.classList.add('layout-container');
  element.innerHTML = '<div class="body"><span class="title"></span></div>';
  return element;
}

export default {
  cssClass,
  cssStyle,
  createElement,
};
